import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { NewdanhmuckhohangAction } from 'src/actions/newdanhmuckhohang.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getNewdanhmuckhohangStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import { isGrantPermission } from 'src/utils/utils';

const NewdanhmuckhohangLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedNewdanhmuckhohangIds, setSelectedNewdanhmuckhohangIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.newdanhmuckhohang);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(NewdanhmuckhohangAction.updateFilter(payload));
    dispatch(NewdanhmuckhohangAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedNewdanhmuckhohangIds;

    if (event.target.checked) {
      newSelectedNewdanhmuckhohangIds = items.map((newdanhmuckhohang) => newdanhmuckhohang.id);
    } else {
      newSelectedNewdanhmuckhohangIds = [];
    }

    setSelectedNewdanhmuckhohangIds(newSelectedNewdanhmuckhohangIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedNewdanhmuckhohangIds.indexOf(id);
    let newSelectedNewdanhmuckhohangIds = [];

    if (selectedIndex === -1) {
      newSelectedNewdanhmuckhohangIds = newSelectedNewdanhmuckhohangIds.concat(selectedNewdanhmuckhohangIds, id);
    } else if (selectedIndex === 0) {
      newSelectedNewdanhmuckhohangIds = newSelectedNewdanhmuckhohangIds.concat(selectedNewdanhmuckhohangIds.slice(1));
    } else if (selectedIndex === selectedNewdanhmuckhohangIds.length - 1) {
      newSelectedNewdanhmuckhohangIds = newSelectedNewdanhmuckhohangIds.concat(selectedNewdanhmuckhohangIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedNewdanhmuckhohangIds = newSelectedNewdanhmuckhohangIds.concat(
        selectedNewdanhmuckhohangIds.slice(0, selectedIndex),
        selectedNewdanhmuckhohangIds.slice(selectedIndex + 1)
      );
    }

    setSelectedNewdanhmuckhohangIds(newSelectedNewdanhmuckhohangIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, newdanhmuckhohang) => {
    setSelected(newdanhmuckhohang);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(NewdanhmuckhohangAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(NewdanhmuckhohangAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: '500px', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Mã
                </TableCell>
                <TableCell>
                  Tên
                </TableCell>
                <TableCell>
                  Thủ kho
                </TableCell>
                <TableCell>
                  Địa chỉ
                </TableCell>
                <TableCell>
                  Số điện thoại
                </TableCell>
                <TableCell>
                  Email
                </TableCell>
                <TableCell>
                  Thời điểm tạo
                </TableCell>
                {(role.priority < 4) && <TableCell>
                  Chức năng
                </TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((newdanhmuckhohang, index) => (
                newdanhmuckhohang ? <TableRow
                  hover
                  key={newdanhmuckhohang.id}
                  selected={selectedNewdanhmuckhohangIds.indexOf(newdanhmuckhohang.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmuckhohang.ma}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmuckhohang.ten}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmuckhohang.thu_kho}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmuckhohang.dia_chi}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmuckhohang.sdt}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmuckhohang.email}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {moment(newdanhmuckhohang.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  {(role.priority < 4) && <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(newdanhmuckhohang.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, newdanhmuckhohang)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>}
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default NewdanhmuckhohangLookupDetail;
